import React from 'react';
import { Box, TextField } from '@mui/material';
import PinIcon from '@mui/icons-material/Pin';
import InputAdornment from '@mui/material/InputAdornment';

export default function PromotionalCode() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
      <TextField
        id="input-with-icon-textfield"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PinIcon />
            </InputAdornment>
          ),
        }}
        placeholder='Código promocional'
        variant="outlined"
      />
    </Box>
  );
}
/*

import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import PinIcon from '@mui/icons-material/Pin';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import {envioCorreo}from "../../services/motorService";

export default function PromotionalCode() {
  const [loading, setLoading] = useState(false);

  const handleApplyCode = async () => {


    setLoading(true);
    try {
      const nombre = "JUAN PEREZ";
      const email = "evelyn.jodus@admintour.com"
      const response = await envioCorreo(nombre, email);
      console.log('Respuesta del backend:', response.data);
      alert('Código aplicado y correo enviado');
    } catch (error) {
      console.error('Error al aplicar código:', error);
      alert('Error al aplicar el código');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
      <TextField
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PinIcon />
            </InputAdornment>
          ),
        }}
        placeholder="Código promocional"
        variant="outlined"
      />
      <Button 
        variant="contained" 
        onClick={handleApplyCode} 
      >
        {loading ? 'Enviando...' : 'Aplicar'}
      </Button>
    </Box>
  );
}
*/